import { appConfig } from "@common/config/app.config";
import { applyAuthHeader } from "@common-reducers/backend-api/apply-auth-header";

type SignedUpload = { url?: string; publicUrl?: string; headers?: Record<string, string> };

// function that starts the process of uploading the image to google cloud bucket
export async function handleUpload(base64file: string, mimeType: string) {
  const res2 = await fetch(base64file);
  const blob = await res2.blob();

  //get signe url
  const signedURL = await getSignedURL(mimeType, blob.size);

  // check if we have a signed URL
  if (signedURL.url) {
    const uploadResponse = await uploadImage(signedURL.url, blob, mimeType, signedURL.headers);
    return { image_url: signedURL.publicUrl, uploadResponse };
  }
}

// function that gets the signed url
// #367: the backend only signs for a signed-in user, so send the JWT like the API baseQuery does.
// The lazy import breaks the auth-service <-> backend-api module cycle.
export const getSignedURL = async (mimeType: string, contentLength?: number): Promise<SignedUpload> => {
  const headers = new Headers({ "Content-Type": "application/json" });
  await applyAuthHeader(headers, undefined, async () => {
    const { authService } = await import("@/common/bt-auth/auth-service");
    return authService.getPersistedToken();
  });
  const res = await fetch(`${appConfig.API_ENDPOINT}/actions`, {
    method: "POST",
    headers,
    body: JSON.stringify({ cmd: "signed-upload-url", contentType: mimeType, contentLength }),
  });
  return res.json();
};

// function that uploads image to the google bucket
// `extraHeaders` are the signed headers the backend returns (the size range), which the PUT must carry.
export const uploadImage = async (
  signedURL: string,
  blob: any,
  mimeType: string,
  extraHeaders: Record<string, string> = {},
) => {
  return await fetch(signedURL, {
    method: "PUT",
    headers: {
      "Content-Type": mimeType,
      ...extraHeaders,
    },
    body: blob,
  });
};
